import naja from 'naja';
import AddToBasketExtension from "@weseus/cms-eshop-baskets/assets/js/front/addToBasket.naja";

naja.registerExtension(AddToBasketExtension);